<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      ref="table"
      row-id="sampleCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :radio-config="{ highlight: true }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImage="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displaySampleName="{ row }">
        <TableLabel :value="row.sampleStyleNo" />
        <TableLabel :value="row.sampleName" />
        <TableLabel :value="row.sampleNameEn" />
      </template>
      <template v-slot:displaySample="{ row }">
        <TableLabel
          :label="$l('table_label_category') || '品类'"
          :value="row.categoryName"
        />
        <TableLabel
          :label="$l('table_label_sampleSource') || '来源'"
          :value="row.v_sampleSource"
        />
        <TableLabel
          :label="$l('table_label_sampleSpec') || '尺寸'"
          :value="`${row.sampleSpec} ${row.sampleSizeUnit || ''}`"
        />
      </template>
      <template v-slot:expoSampleStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.expoSampleStatus === 'D'
              ? 'danger'
              : row.expoSampleStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_expoSampleStatus }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.expoSampleBrand" />
        <TableLabel :value="row.expoSampleName" />
      </template>
      <template v-slot:displayFabric="{ row }">
        <div v-if="row.isFabricPosition == 'Y'">
          <TableLabel
            :label="$l('table_label_faceFabric') || 'FACE'"
            :value="row.faceFabric"
          />
          <TableLabel
            :label="$l('table_label_backFabric') || 'BACK'"
            :value="row.backFabric"
          />
          <TableLabel
            :label="$l('table_label_innerFabric') || 'INNER'"
            :value="row.innerFabric"
          />
        </div>
        <div v-else>
          <TableLabel :value="row.faceFabric" />
        </div>
      </template>
      <template v-slot:displayScm="{ row }">
        <TableLabel
          :label="$l('table_label_costPrice') || '成品价格'"
          :value="`${format(row.costPrice) || '0'} ${row.costCurrency || ''}`"
        />
        <TableLabel :value="row.scmName" />
      </template>
      <template v-slot:displayQuoted="{ row }">
        <TableLabel
          :label="$l('table_label_quotedMethod') || '报价方式'"
          :value="row.quotedMethod"
        />
        <TableLabel
          :label="$l('table_label_quotedPrice') || '参考报价'"
          :value="`${format(row.quotedPrice) || '0'} ${row.currencyUnit || ''}`"
        />
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableLabel from '../table/label.vue'
import { format } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { type: Boolean, default: false },
    type: String,
  },
  components: { TableLabel },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
      format: (n) => format(n),
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.table.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
